module.exports = __webpack_public_path__ + "img/Payment-Details.d0d12139.jpg";